import { INeoAction } from './../Actions.interface';
import { REQUEST_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { IBookingSummaryEvent } from '../../Models/DTO/Booking.models';

export default function SummaryReducer(
  state: Record<string, IBookingSummaryEvent> = {},
  action: INeoAction,
) {
  const { name, payload, status } = action;

  if (status === STATUS.SUCCESS) {
    if (name == REQUEST_ACTIONS.BOOKING_SUMMARY) {
      return (payload as IBookingSummaryEvent[]).reduce((map, event) => {
        map[event.eventId] = event;
        return map;
      }, {} as Record<string, IBookingSummaryEvent>);
    }
  }

  return state;
}
